export const delay = async (interval: number): Promise<void> => {
  return await new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, interval);
  });
};

export function isCallback<T>(maybeFunc: T | unknown): maybeFunc is T {
  return typeof maybeFunc === 'function';
}

export const sortBy = <T>(key: keyof T, reverse: boolean = false) => {
  return (a: T, b: T) => {
    if (a[key] === b[key]) {
      return 0;
    }
    return (a[key] < b[key] ? -1 : 1) * (reverse ? -1 : 1);
  };
};

export const sortStringByIgnoreCase = <T>(key: keyof T, reverse: boolean = false) => {
  return (a: T, b: T) => {
    const c = (a[key] as string).toLowerCase();
    const d = (b[key] as string).toLowerCase();
    if (c === d) {
      return 0;
    }
    return (c < d ? -1 : 1) * (reverse ? -1 : 1);
  };
};

export const enumKeyByValue = <TEnumKey extends string, TEnumVal extends string | number>(myEnum: { [key in TEnumKey]: TEnumVal }, enumValue: TEnumVal): string => {
  const keys = (Object.keys(myEnum) as TEnumKey[]).filter((x) => myEnum[x] === enumValue);
  return keys.length > 0 ? keys[0] : '';
};

export const toClipboard = (value: string) => {
  return () => {
    void navigator.clipboard.writeText(value);
  };
};

export const any = <T>(arr: T[], filterFn: (item: T) => boolean): boolean => {
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    if (filterFn(item)) {
      return true;
    }
  }
  return false;
}